@use "@fukuri-admins/ui/layout" as *;

.Screen {
  display: flex;
  background-color: background('Primary');
  padding-left: $SideMenuWidth;
  min-height: 100vh;
  @media screen and (max-width: $TB) {
    flex-direction: column;
    padding-left: 0;
    padding-top: 40px;
  }
}

.NoSideMenu {
  padding-left: 0;
}
